import { useEffect } from 'react'
import type { ActivationRedirectProps } from '../types'
import { useNavigate } from 'react-router-dom'

export const useActivationRedirect = (props: ActivationRedirectProps) => {
    const { activationObject, isDocumentClicked, isError } = props

    const navigate = useNavigate()

    useEffect(() => {
        if (isError) navigate('/')
        if (activationObject) {
            switch (activationObject.actualWizardStep.mainStep) {
                case 'Finish':
                    navigate('/thanks')
                    break
                case 'Redirect':
                    navigate('/redirect')
                    break
                default:
                    isDocumentClicked ? navigate('/wizard') : navigate('/')
                    break
            }
        }
    }, [activationObject, isDocumentClicked, isError, navigate])
}
